import DashboardHome from "../pages/admin/DashboardHome";
import PatientForm from "../components/admin/PatientForm";
import Registration from "../components/admin/Registration";
import UpdatePatient from "../components/admin/UpdatePatient";
import ConstanteForm from "../components/admin/ConstanteForm";
import ConstanteRegistration from "../components/admin/ConstanteRegistration";
import ConstanteView from "../components/admin/ConstanteView";
import ConstanteUpdate from "../components/admin/ConstanteUpdate";
import PatientAccount from "../components/admin/PatientAccount";
import PatientAccountRegistration from "../components/admin/PatientAccountRegistration";
import PatientAccountView from "../components/admin/PatientAccountView";
import PatientAccountUpdate from "../components/admin/PatientAccountUpdate";
// ❌ on exclut ici toutes les routes d'administration
// comme account/admin, doctor, etc.

export const sharedSecretaryRoutes = [
  { path: "accueil", element: <DashboardHome /> },
  { path: "patient", element: <PatientForm /> },
  { path: "patient/new", element: <Registration /> },
  { path: "patient/view/:id", element: <PatientAccountView /> },
  { path: "patient/edit/:id", element: <UpdatePatient /> },
  { path: "constante", element: <ConstanteForm /> },
  { path: "constante/new", element: <ConstanteRegistration /> },
  { path: "constante/view/:id", element: <ConstanteView /> },
  { path: "constante/edit/:id", element: <ConstanteUpdate /> },
  { path: "account/patient", element: <PatientAccount /> },
  { path: "account/patient/new", element: <PatientAccountRegistration /> },
  { path: "account/patient/view/:id", element: <PatientAccountView /> },
  { path: "account/patient/edit/:id", element: <PatientAccountUpdate /> },
];
